const ALL_COLLECTIONS = [
  'cleanser','toner','serum','essence','face-cream','face-mask','eye-care',
  'lip-gloss','lip-oil','lip-balm','lip-mask','lip-scrub','lip','oil','mask',
  'hair-oil','shampoo','conditioner','hair-mask','hair-serum',
  'body-lotion','body-wash','body-scrub','hand-cream','cream','foot-care','hand','foot','mask','face','hair',
  'sunscreen','sun-stick','after-sun-care',
  'mens-cleanser','mens-moisturizer','beard-care'
];
const PARENT_COLLECTION_MAP = {
  'skincare':['cleanser','toner','serum','essence','face-cream','face-mask','eye-care'],
  'lip-care':['lip-gloss','lip-oil','lip-balm','lip-mask','lip','lip-scrub'],
  'hair-care':['hair-oil','shampoo','conditioner','hair-mask','hair','hair-serum'],
  'body-care':['body-lotion','body-wash','body-scrub','body','hand','foot','hand-cream','foot-care'],
  'sun-care':['sunscreen','sun-stick','sun','after-sun-care'],
  'mens-care':['mens-cleanser','mens-moisturizer','mens','beard-care']
};
const KEYWORD_COLLECTION_MAP = {
  'moistur':['face-cream','body-lotion'],'cream':['face-cream','hand-cream'],
  'serum':['serum','hair-serum'],'essence':['essence'],'toner':['toner'],
  'cleanser':['cleanser','mens-cleanser'],'clean':['cleanser','body-wash'],
  'wash':['cleanser','body-wash','shampoo'],'foam':['cleanser'],
  'mask':['face-mask','hair-mask','lip-mask'],'eye':['eye-care'],
  'lip':['lip-oil','lip-balm','lip-gloss','lip-mask','lip-scrub'],
  'gloss':['lip-gloss'],'balm':['lip-balm'],'scrub':['lip-scrub','body-scrub'],
  'hair':['hair-oil','hair-serum','hair-mask','shampoo','conditioner'],
  'shampoo':['shampoo'],'condition':['conditioner'],
  'body':['body-lotion','body-wash','body-scrub'],'lotion':['body-lotion','face-cream'],
  'hand':['hand-cream'],'foot':['foot-care'],'sun':['sunscreen','sun-stick','after-sun-care'],
  'spf':['sunscreen','sun-stick'],'sunscreen':['sunscreen'],
  'whitening':['serum','face-cream','toner'],'brighten':['serum','toner','essence'],
  'acne':['cleanser','toner','serum'],'oily':['cleanser','toner'],
  'dry':['face-cream','serum','body-lotion'],'hydrat':['serum','essence','face-cream'],
  'anti-aging':['serum','eye-care','face-cream'],'wrinkle':['serum','eye-care','face-cream'],
  'dark':['eye-care','serum'],'pore':['toner','serum','cleanser'],
  'men':['mens-cleanser','mens-moisturizer'],'beard':['beard-care'],'oil':['hair-oil','lip-oil','face-cream']
};
const REGION_CONFIG = {
  middle_east:{label:'Middle East Picks',collections:['sunscreen','face-cream','cream','serum','body-lotion'],countries:['SA','AE','KW','QA','EG','IQ','IR','JO','BH','OM','LB','YE']},
  southeast_asia:{label:'Southeast Asia Picks',collections:['face-cream','cream','serum','sunscreen','toner','essence'],countries:['TH','MY','ID','PH','VN','SG','MM','KH','LA','BN']},
  africa:{label:'Africa Favorites',collections:['body-lotion','lotion','face-cream','hair-oil','oil','cream','body-wash'],countries:['NG','GH','ZA','KE','ET','TZ','CI','SN','CM','UG','RW']},
  east_asia:{label:'Asia Bestsellers',collections:['essence','serum','face-mask','mask','toner','eye-care','eye'],countries:['CN','JP','KR','TW','HK','MO']},
  europe:{label:'Europe Top Picks',collections:['serum','face-cream','body-lotion','lotion','cleanser'],countries:['GB','DE','FR','IT','ES','NL','SE','NO','DK','FI','BE','CH','AT','PL']},
  north_america:{label:'North America Loves',collections:['sunscreen','serum','cleanser','cream','face-cream'],countries:['US','CA']},
  default:{label:'You May Also Like',collections:['face-cream','cream','serum','cleanser','sunscreen']}
};

async function fetchCollectionProducts(handle,limit=20){try{const url=`/collections/${handle}/products.json?limit=${limit}`;const res=await fetch(url);if(!res.ok)return[];const data=await res.json();return data.products||[];}catch{return[];}}
async function fetchProductsFromCollections(handles,limit=8){if(!handles.length)return[];const perCol=Math.ceil((limit*2.5)/handles.length);const promises=handles.map(h=>fetchCollectionProducts(h,perCol));const groups=await Promise.all(promises);const pool=groups.flat();const seen=new Set();const unique=pool.filter(p=>{if(seen.has(p.id))return false;seen.add(p.id);return true;});return shuffle(unique).slice(0,limit);}
function parseSearchKeywords(){const ref=document.referrer;if(!ref)return[];const engines=[{host:'google',param:'q'},{host:'bing',param:'q'},{host:'baidu',param:'wd'},{host:'yahoo',param:'p'},{host:'yandex',param:'text'},{host:'naver',param:'query'}];for(const engine of engines){if(ref.includes(engine.host)){const q=new URL(ref).searchParams.get(engine.param)||'';return q.toLowerCase().split(/[\s,+&]+/).filter(w=>w.length>1);}}return[];}
function keywordsToCollections(keywords){const result=new Set();for(const kw of keywords){for(const [pattern,cols] of Object.entries(KEYWORD_COLLECTION_MAP)){if(kw.includes(pattern)||pattern.includes(kw)){cols.forEach(c=>result.add(c));}}if(ALL_COLLECTIONS.includes(kw))result.add(kw);}return [...result];}
function detectCurrentPageCollection(){const path=window.location.pathname.toLowerCase();const title=document.title.toLowerCase();const result=new Set();const colMatch=path.match(/\/collections\/([\w-]+)/);if(colMatch){const handle=colMatch[1];if(ALL_COLLECTIONS.includes(handle)){result.add(handle);}else if(PARENT_COLLECTION_MAP[handle]){PARENT_COLLECTION_MAP[handle].forEach(c=>result.add(c));}}if(path.includes('/products/')){try{const meta=window.ShopifyAnalytics?.meta?.product;if(meta?.type){const type=meta.type.toLowerCase().replace(/\s+/g,'-');if(ALL_COLLECTIONS.includes(type))result.add(type);}if(meta?.collections){meta.collections.forEach(c=>{const h=c.handle?.toLowerCase();if(h&&ALL_COLLECTIONS.includes(h))result.add(h);});}}catch{}}return [...result];}
const STATS_KEY='banlilo_view_stats';
function recordCollectionView(handle){if(!ALL_COLLECTIONS.includes(handle))return;const stats=JSON.parse(localStorage.getItem(STATS_KEY)||'{}');stats[handle]=(stats[handle]||0)+1;localStorage.setItem(STATS_KEY,JSON.stringify(stats));}
function getTopCollections(n=2){return Object.entries(JSON.parse(localStorage.getItem(STATS_KEY)||'{}')).filter(([h])=>ALL_COLLECTIONS.includes(h)).sort((a,b)=>b[1]-a[1]).slice(0,n).map(([h])=>h);}
async function detectRegion(){const cached=sessionStorage.getItem('banlilo_region');if(cached)return cached;try{const res=await fetch('https://ipapi.co/json/',{signal:AbortSignal.timeout(3000)});const data=await res.json();const cc=data.country_code||'';for(const [region,cfg] of Object.entries(REGION_CONFIG)){if(cfg.countries?.includes(cc)){sessionStorage.setItem('banlilo_region',region);return region;}}}catch{const lang=(navigator.language||'').toLowerCase();let region='default';if(lang.startsWith('ar'))region='middle_east';else if(['th','ms','id','vi','fil'].some(l=>lang.startsWith(l)))region='southeast_asia';else if(['zh','ja','ko'].some(l=>lang.startsWith(l)))region='east_asia';else if(['de','fr','it','es','nl'].some(l=>lang.startsWith(l)))region='europe';sessionStorage.setItem('banlilo_region',region);return region;}sessionStorage.setItem('banlilo_region','default');return 'default';}
function shuffle(arr){const a=[...arr];for(let i=a.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[a[i],a[j]]=[a[j],a[i]];}return a;}

// ==============================================
// 原生产品卡片渲染（100% 和你网站一样）
// ==============================================
function renderProductCard(product) {
  const img = product.images?.[0] || {};
  const imgUrl = img.src || '';
  const imgAlt = img.alt || product.title;
  const variant = product.variants?.[0] || {};
  const price = variant.price || '0';
  const compareAt = variant.compare_at_price || '';
  const productId = product.id;
  const handle = product.handle;
  const variantId = variant.id || '';
  const priceFormatted = `$${parseFloat(price).toFixed(2)} USD`;
  const compareFormatted = compareAt ? `$${parseFloat(compareAt).toFixed(2)} USD` : '';
  const onSale = compareAt && parseFloat(compareAt) > parseFloat(price);

  return `
<div class="resource-list__item">
<product-card class="product-card size-style" style="--size-style-width: ;--size-style-height: ;" data-product-id="${productId}" data-product-transition="true" data-featured-media-url="${imgUrl}">
  <a href="/products/${handle}?variant=${variantId}" class="product-card__link">
    <span class="visually-hidden">${product.title}</span>
  </a>
  <div class="product-card__content layout-panel-flex layout-panel-flex--column product-grid__card spacing-style border-style gap-style">
    <div class="card-gallery spacing-style border-style" style="--gallery-aspect-ratio: 1;">
      <a class="contents" href="/products/${handle}?variant=${variantId}" aria-label="${product.title}">
        <slideshow-component initial-slide="0" infinite="" in-viewport="">
          <slideshow-container>
            <slideshow-slides tabindex="-1">
              <slideshow-slide style="--product-media-fit: cover;" class="product-media-container media-fit product-media-container--image">
                <div class="product-media" style="--ratio: 1.0">
                  <img src="${imgUrl}" alt="${imgAlt}" loading="lazy" class="product-media__image">
                </div>
              </slideshow-slide>
            </slideshow-slides>
          </slideshow-container>
        </slideshow-component>
      </a>
      <div class="product-badges product-badges--top-left"></div>
      <quick-add-component class="quick-add color-scheme-1">
        <product-form-component>
          <form method="post" action="/cart/add" class="shopify-product-form" novalidate>
            <input type="hidden" name="id" value="${variantId}">
            <add-to-cart-component>
              <button type="submit" class="button button quick-add__button quick-add__button--add add-to-cart-button">
                <span class="add-to-cart-text">
                  <span class="add-to-cart-text__content is-visually-hidden-mobile">Add</span>
                </span>
              </button>
            </add-to-cart-component>
          </form>
        </product-form-component>
      </quick-add-component>
    </div>
    <div class="product-grid-view-zoom-out--details">
      <h3 class="h4">${product.title}</h3>
    </div>
    <product-price class="text-block text-block--align-center text-center h6 spacing-style">
      <div>
        <div class="price__regular">
          <span class="price">${priceFormatted}</span>
        </div>
        <div class="price__sale ${onSale ? '' : 'price__hidden'}">
          <span class="price-item__group">
            <span class="price-item--sale price">${priceFormatted}</span>
          </span>
          <span class="price-item__group ${onSale ? '' : 'price__hidden'}">
            <span class="price-item--regular compare-at-price">${compareFormatted}</span>
          </span>
        </div>
      </div>
    </product-price>
    <a class="contents user-select-text" href="/products/${handle}?variant=${variantId}">
      <div class="spacing-style text-block text-block--align-center custom">
        <p role="heading" aria-level="3">${product.title}</p>
      </div>
    </a>
  </div>
</product-card>
</div>
  `;
}

// ==============================================
// 主逻辑
// ==============================================
async function getSmartRecommendations(limit=8){
  const keywords=parseSearchKeywords();
  if(keywords.length>0){const kwCols=keywordsToCollections(keywords);if(kwCols.length){const p=await fetchProductsFromCollections(kwCols,limit);if(p.length>=4)return {label:'You May Also Like',products:p};}}
  const pageCols=detectCurrentPageCollection();
  if(pageCols.length){const p=await fetchProductsFromCollections(pageCols,limit);if(p.length>=4)return {label:'You May Also Like',products:p};}
  const topCols=getTopCollections(2);
  if(topCols.length){const p=await fetchProductsFromCollections(topCols,limit);if(p.length>=4)return {label:'Recommended For You',products:p};}
  const region=await detectRegion();
  const regionCfg=REGION_CONFIG[region]||REGION_CONFIG.default;
  const p=await fetchProductsFromCollections(regionCfg.collections,limit);
  if(p.length>=4)return {label:regionCfg.label,products:p};
  const fallback=await fetchProductsFromCollections(['face-cream','serum','hair-oil'],limit);
  return {label:'You May Also Like',products:fallback};
}

async function initSmartRecommendations(){
  const section=document.getElementById('smart-recommendations');
  const grid=document.getElementById('smart-rec-grid');
  if(!section||!grid)return;
  const limit = parseInt(section.dataset.productLimit, 10) || 8;
  detectCurrentPageCollection().forEach(recordCollectionView);
  const {label,products}=await getSmartRecommendations(limit);
  document.querySelector('.section-title').textContent=label;
  grid.innerHTML=products.map(renderProductCard).join('');
}

document.addEventListener('DOMContentLoaded',initSmartRecommendations);